import Config from '../../appConfig';
import {
  generateHeadersByCookieValuesFilterByEqual,
  generateHeadersByCookieValuesFilterByStartsWith,
  generateCustomHeadersForTracking,
  generateStatsigHeaderByPageType,
} from '../../common/network/apiUtils';
import {allowedKeysForTolkien, hbAdultCookieKey} from '../../common/network/networkConstants';
import {STATSIG_PAGE_TYPES} from '../../utils/statsig';

function TagApiFactory(storefrontApiClient) {
  const tagApi = {
    getTagProducts(params, cookies) {
      return storefrontApiClient.get('/tagSearch', {
        headers: {
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [hbAdultCookieKey]),
          ...generateStatsigHeaderByPageType(cookies, STATSIG_PAGE_TYPES.TAG),
        },
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },
    getTagPageSeo(params) {
      return storefrontApiClient.get('/tagpageseo', {
        headers: {},
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    }
  };
  return tagApi;
}

export default TagApiFactory;
